var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F6867A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2562 34.0128C38.6186 33.6687 38.9072 33.2544 39.1044 32.7952C39.3016 32.336 39.4033 31.8415 39.4033 31.3417C39.4033 30.842 39.3016 30.3475 39.1044 29.8883C38.9072 29.4291 38.6186 29.0148 38.2562 28.6707C37.5144 27.9666 36.5307 27.5741 35.508 27.5741C34.4853 27.5741 33.5016 27.9666 32.7598 28.6707L30.002 31.4285L27.2441 28.6707C26.5023 27.9666 25.5186 27.5741 24.4959 27.5741C23.4732 27.5741 22.4895 27.9666 21.7477 28.6707C21.3853 29.0148 21.0967 29.4291 20.8995 29.8883C20.7023 30.3475 20.6006 30.842 20.6006 31.3417C20.6006 31.8415 20.7023 32.336 20.8995 32.7952C21.0967 33.2544 21.3853 33.6687 21.7477 34.0128L30.002 42.0357L38.2562 34.0128ZM30.002 24.6785C31.0249 24.6785 32.006 24.2721 32.7294 23.5488C33.4527 22.8254 33.8591 21.8444 33.8591 20.8214C33.8591 19.7984 33.4527 18.8173 32.7294 18.094C32.006 17.3706 31.0249 16.9642 30.002 16.9642C28.979 16.9642 27.9979 17.3706 27.2745 18.094C26.5512 18.8173 26.1448 19.7984 26.1448 20.8214C26.1448 21.8444 26.5512 22.8254 27.2745 23.5488C27.9979 24.2721 28.979 24.6785 30.002 24.6785Z",
    stroke: "white",
    strokeWidth: 1.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(16.502 15.9999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHart);
export default __webpack_public_path__ + "static/media/hart.754d72f83c602e36d3f02b288dc2091e.svg";
export { ForwardRef as ReactComponent };